import RequestAbstract from "../abstract";

export default class AccountingWalletTransfers extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-wallet-transfers";
    }

}
